<template>
  <modal title="Add track to playlist" ref="modal">
    <div class="container-fluid pt-4 playlist-add-container">
      <div class="mb-3 row">
        <div class="col-sm-4">
          <label for="what" class="col-form-label">What to add:</label>
        </div>
        <div class="col-sm-8">
          <select v-model="what" class="form-select">
            <option value="latest">Latest version of "{{ songName }}"</option>
            <option :value="mixID">Version #{{ mixVersion }} of "{{ songName }}"</option>
          </select>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-sm-4">
          <label for="playlist" class="col-form-label">Playlist:</label>
        </div>
        <div class="col-sm-8">
          <select v-model="playlist" class="form-select">
            <option v-for="p in playlists" :value="p.id" :key="p.id">{{ p.name }}</option>
            <option value="_new">&lt;new playlist&gt;</option>
          </select>
        </div>
      </div>
      <div v-if="playlist == '_new'" class="mb-3 row">
        <div class="col-sm-4">
          <label for="playlist_name" class="col-form-label">Playlist Name:</label>
        </div>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="playlist_name"
            v-model="playlistName"
            placeholder="playlist name..."
          />
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col">
          <button
            type="button"
            class="btn btn-primary"
            @click="save"
            :disabled="(playlist == '_new' && !playlistName) || saving"
            aria-label="Add Track"
          >
            <span v-if="saving">...</span>
            <span v-else-if="playlist == '_new'"> Create Playlist </span>
            <span v-else> Add Track to Playlist </span>
          </button>
        </div>
      </div>
      <div class="mb-3 row">
         <div class="col">
            {{ message }}
         </div>
      </div>
    </div>
  </modal>
</template>

<style>
#add-to-playlist-modal .modal-body {
  padding: 0px;
}

.playlist-add-container {
  border: 1px solid #ccc;
}
</style>

<script>
import { post_csrf } from "../utils/csrf"
import Modal from "./modal.vue"

function createPlaylist(name) {
  return post_csrf("/playlists.json", { name: name }).then(r => {
    if (!r.ok) throw new Error("HTTP error " + r.status)
    return r.json()
  })
}

function addToPlaylist(playlistID, what, songID) {
  let data
  if (what == "latest") {
    data = { object_type: "Song", object_id: songID }
  } else {
    data = { object_type: "Mix", object_id: what }
  }

  return post_csrf(`/playlists/${playlistID}/tracks.json`, data)
}

export default {
  props: ["mixVersion", "mixID", "songID", "songName"],
  components: { Modal },
  data() {
    return {
      playlists: null,
      playlist: null,
      playlistName: "",
      what: "latest",
      saving: false,
      message: "",
    }
  },
  methods: {
    async showModal(what) {
      this.playlistName = ""
      if (what) this.what = what
      else this.what = "latest"
      this.saving = false
      this.message = ""

      if (!this.playlists) {
        const res = await fetch("/playlists.json")
        if (res.status == 200) {
          const json = await res.json()
          this.playlists = json['playlists']
        }
      }
      if (!this.playlists || !this.playlists.length) {
        this.playlist = "_new"
      } else {
        this.playlist = this.playlists[0].id
      }
      this.$refs.modal.show()
    },
    closeModal() {
      this.$refs.modal.close()
    },
    async save(ev) {
      this.saving = true
      if (this.playlist == "_new") {
        const playlist = await createPlaylist(this.playlistName)
        const playlistID = playlist["playlist"]["id"]
        const res = await addToPlaylist(playlistID, this.what, this.songID)
        window.location.pathname = `/playlists/${playlistID}`
      } else {
        const res = await addToPlaylist(this.playlist, this.what, this.songID)
        if (res.status >= 400) {
          const json = await res.json()
          this.message = "error adding to playlist: " + JSON.stringify(json)
        } else {
          this.message = "Added!"
          setTimeout(this.closeModal, 800)
        }
      }
      this.saving = false
    },
  },
}
</script>
